import { useSubscription } from './use-subscription'

export function useFeature(key: string): { hasFeature: boolean; isLoading: boolean } {
  const { data, isLoading } = useSubscription()

  // While loading, treat as granted to avoid flashing the upgrade prompt
  if (isLoading || !data) return { hasFeature: true, isLoading }

  // Hard block if subscription has expired, been suspended, or cancelled
  const isExpired = !!data.expires_at && new Date(data.expires_at) < new Date()
  if (isExpired || data.status === 'suspended' || data.status === 'cancelled') {
    return { hasFeature: false, isLoading: false }
  }

  const hasFeature = data.plans?.plan_features.some((f) => f.feature_key === key) ?? false
  return { hasFeature, isLoading: false }
}
